import { ReactElement } from 'react'
import cn from 'classnames'
import { BundleItem } from '@pylot-data/pylotschema'
import { ProductPrice } from '@components/common/ProductPrice/ProductPrice'
import s from './BundleProducts.module.scss'

interface BundleProductsProps {
    items: BundleItem[]
}

const BundleProducts = ({ items }: BundleProductsProps): ReactElement => {
    const bundleQuantity = items?.length
    const title = `Este set incluye ${bundleQuantity} productos`

    const bundleItems =
        items &&
        items
            .sort((a, b) => a?.position! - b?.position!)
            .map((item, index) => {
                const options = item?.options && item.options[0]
                const qty = `${options?.quantity}X `
                const img = options && options?.product?.image?.url
                const priceRange = options?.product?.price_range ?? null

                return (
                    <div className={s['product-container']} key={index}>
                        <div className={s['image-container']}>
                            <img
                                src={img!}
                                alt={
                                    options?.label
                                        ? options?.label
                                        : 'placeholder'
                                }
                                width={200}
                                height={200}
                                className={cn(s['product-img'], 'contain')}
                            />
                        </div>
                        <div className={s['product-info']}>
                            <div className={s['product-name']}>
                                {qty}
                                {options?.label}
                            </div>
                            <div className={s['product-price']}>
                                <ProductPrice priceRange={priceRange} />
                            </div>
                        </div>
                    </div>
                )
            })

    return (
        <div className={s['bundleProducts-container']}>
            <p className={s['bundleProducts-title']}>{title}</p>
            <div className={s['productList-container']}>{bundleItems}</div>
        </div>
    )
}

export default BundleProducts
